import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { IRouteModel } from '../../Routes';
import stocks from '../../assets/images/icons/Stocks_icon.svg';
import { Box, Icon, ListItem, ListItemText, SvgIcon, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../utils/theme';
import { SvgIconComponent } from '@mui/icons-material';

const useStyles = makeStyles(() => {
  return {
    item: {
      height: 39,
      width: 166,
      paddingRight: 12,
      paddingLeft: 15,
      '&$selected': {
        height: 41,
        backgroundColor: Colors.third,
        borderRadius: '0px 100px 100px 0px',
        '&:hover': {
          height: 41,
          backgroundColor: Colors.third,
          borderRadius: '0px 100px 100px 0px'
        }
      },
      '&:hover': {
        height: 39,
        backgroundColor: Colors.third,
        borderRadius: '0px 100px 100px 0px'
      }
    },
    itemClosed: {
      height: 32,
      width: 32,
      marginLeft: 14,
      marginTop: 3.5,
      marginBottom: 3.5,
      '&$selected': {
        backgroundColor: Colors.third,
        borderRadius: '100px',
        '&:hover': {
          backgroundColor: Colors.third,
          borderRadius: '100px'
        }
      },
      '&:hover': {
        backgroundColor: Colors.third,
        borderRadius: '100px'
      }
    },
    nestedItem: {
      height: 28,
      width: 166,
      paddingRight: 12,
      paddingLeft: 15,
      '&$selected': {
        height: 28,
        backgroundColor: Colors.third,
        borderRadius: '0px 100px 100px 0px',
        '&:hover': {
          height: 28,
          backgroundColor: Colors.third,
          borderRadius: '0px 100px 100px 0px'
        }
      },
      '&:hover': {
        height: 28,
        backgroundColor: Colors.third,
        borderRadius: '0px 100px 100px 0px'
      }
    },
    nestedItemClosed: {
      height: 28,
      width: 32,
      marginLeft: 14,
      marginTop: 3.5,
      marginBottom: 3.5,
      '&$selected': {
        backgroundColor: Colors.third,
        borderRadius: '100px',
        '&:hover': {
          backgroundColor: Colors.third,
          borderRadius: '100px'
        }
      },
      '&:hover': {
        backgroundColor: Colors.third,
        borderRadius: '100px'
      }
    }
  };
});

type IPropType = {
  route: IRouteModel;
  selected: string;
  open: boolean;
  nested?: boolean;
  handleSelectedChanged(path: string): void;
};

const NavItem: React.FunctionComponent<IPropType> = (props: IPropType) => {
  const { route, handleSelectedChanged, selected, open, nested } = props;

  const itemClick = (e: React.MouseEvent<HTMLElement, MouseEvent>, path: string) => {
    e.stopPropagation();
    handleSelectedChanged(path);
  };

  const getId = () => `${route.name.replaceAll(' ', '-')}-Button`;

  const isSelected = () => selected == route.path;

  return (
    <ListItem
      id={getId()}
      data-testid={getId()}
      key={route.name}
      selected={isSelected()}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: open ? 'left' : 'center',
        height: nested ? '28px' : isSelected() && open ? '42px' : !open ? '32px' : '40px',
        paddingX: open ? '14px' : '12px',
        paddingLeft: nested && open ? '40px' : open ? '14px' : '12px',
        marginRight: '14px',
        marginY: !open ? '4px' : 0,
        cursor: 'pointer',
        '&.Mui-selected, &:hover': {
          backgroundColor: Colors.third,
          borderRadius: open ? '0px 100px 100px 0px' : '100px'
        }
      }}
      disableGutters={true}
      onClick={(e) => itemClick(e, route.path as string)}
    >
      <SvgIcon component={route.icon as SvgIconComponent} sx={{ color: 'common.white' }} />
      {open && (
        <Box sx={{ color: Colors.white, margin: 0, marginLeft: '8px', fontWeight: 400 }}>
          <Typography style={{ fontSize: nested ? '12px' : '1rem' }}>{route.name}</Typography>
        </Box>
      )}
    </ListItem>
  );
};

export default NavItem;
